export default __webpack_public_path__ + "static/about-us-box-m-97c4d38025ee2ca02554d033ff97979d.png";